export default __webpack_public_path__ + "static/media/loginBg.59e51a35.jpg";